import { render } from "./DKredit.vue?vue&type=template&id=52db9529"
import script from "./DKredit.vue?vue&type=script&lang=js"
export * from "./DKredit.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__